export default {
  methods: {

    getFieldError(fieldName) {
      var form = null
      var formComponent = this.findComponentParent(this.$parent, 'FormGroup')
      if(formComponent)
        form = formComponent.$props.form

      if(form == null || form.errors == null)
        return ''

      var fieldError = form.errors.filter(errorInfo => { return errorInfo.field == fieldName })[0]
      if(fieldError == undefined)
        return ''
        
      return fieldError.message
    },

    resetFieldError(fieldName) {
      var form = null
      var formComponent = this.findComponentParent(this.$parent, 'FormGroup')
      if(formComponent)
        form = formComponent.$props.form

      if(form == null || form.errors == null)
        return

      let errorCount = form.errors.length
      form.errors = form.errors.filter(errorInfo => { return errorInfo.field != fieldName })

      // Update wizard if it's present & errors were removed
      if(errorCount != form.errors.length) {
        var wizardComponent = this.findComponentParent(this.$parent, 'FormWizard')
        if(wizardComponent)
          wizardComponent.displayErrors()
      }
      // Update tabbed box if it's present & errors were removed
      if(errorCount != form.errors.length) {
        var tabBoxComponent = this.findComponentParent(this.$parent, 'TabbedBox')
        if(tabBoxComponent)
          tabBoxComponent.displayErrors()
      }
    }
  }
}
